<script>
import WidgetCard from '@widgets/widget-card.vue'
import WidgetGraph from '@/src/components/widgets/widget-graph.vue'

export default {
  components: {
    WidgetCard,
    WidgetGraph,
  },
  props: {
    player: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      isPlayerGraphsInitiallyOpen: null,
    }
  },
  created() {
    const isPlayerGraphOpen = window.localStorage.getItem(
      'wallaPlayerProfileGraphsCollapsed'
    )
    if (isPlayerGraphOpen === 'true') {
      this.isPlayerGraphsInitiallyOpen = isPlayerGraphOpen === 'true'
    }
  },
  methods: {
    setPlayerDataViewDefault(isPlayerGraphsCollapsed) {
      window.localStorage.setItem(
        'wallaPlayerProfileGraphsCollapsed',
        !isPlayerGraphsCollapsed
      )
    },
  },
}
</script>

<template>
  <WidgetCard
    :show-on-desktop="true"
    :title="$t('expand_graphs')"
    :title-expanded="$t('hide_graphs')"
    :is-initially-open="isPlayerGraphsInitiallyOpen"
    :is-button="true"
    :article-class="$style.cardStyle"
    :sheet-class="$style.mainCard"
    @change="setPlayerDataViewDefault"
  >
    <div :class="$style.layout">
      <v-row>
        <v-col cols="12" lg="4" md="12" sm="12" class="mt-2">
          <WidgetGraph
            :player-id="player.id"
            :sheet-class="$style.upperWidgets"
            graph="TimePerformance"
            :title="$t('charts.time_performance')"
          />
        </v-col>
        <v-col cols="12" lg="4" md="12" sm="12" class="mt-2">
          <WidgetGraph
            :player-id="player.id"
            :sheet-class="$style.upperWidgets"
            graph="ResultsPerformance"
            :title="$t('charts.results_performance')"
          />
        </v-col>
        <v-col cols="12" lg="4" md="12" sm="12" class="mt-2">
          <WidgetGraph
            :player-id="player.id"
            :sheet-class="$style.upperWidgets"
            graph="OpponentRankingPerformance"
            :title="$t('charts.oppenent_ranking_perf')"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" lg="4" md="12" sm="12" class="mt-2">
          <WidgetGraph
            :player-id="player.id"
            :sheet-class="$style.upperWidgets"
            graph="FieldPositionPerformance"
            :title="$t('charts.position_field_perf')"
          />
        </v-col>
        <v-col cols="12" lg="4" md="12" sm="12" class="mt-2">
          <WidgetGraph
            :player-id="player.id"
            :sheet-class="$style.upperWidgets"
            graph="PerformanceAgainsOpponents"
            :title="$t('charts.perf_agains_opponents')"
          />
        </v-col>
        <v-col cols="12" lg="4" md="12" sm="12" class="mt-2">
          <WidgetGraph
            :player-id="player.id"
            :sheet-class="$style.upperWidgets"
            graph="HomeAway"
            :title="$t('charts.home_away')"
          />
        </v-col>
      </v-row>
    </div>
  </WidgetCard>
</template>

<style lang="scss" module>
@import '@design';

.upperWidgets {
  @media screen and (min-width: $screen-lg) {
    height: 16rem;
  }
}

.cardStyle {
  margin-top: 1rem;
}

.mainCard {
  background-color: transparent !important;
}
</style>
